export default __webpack_public_path__ + "static/media/feature_image.b6058c2e.svg";